export const BADGER_DARK_SUPERSET_THEME = {
  token: {
    colorPrimaryBg: '#0b2a44',
    colorPrimaryBgHover: '#0e3a5f',
    colorPrimaryBorder: '#135c93',
    colorPrimaryBorderHover: '#1878c0',
    colorPrimaryHover: '#33a7ff',
    colorPrimary: '#0a8dff',
    colorInfo: '#0a8dff',
    colorPrimaryActive: '#006cd9',
    colorPrimaryTextHover: '#33a7ff',
    colorPrimaryText: '#0a8dff',
    colorPrimaryTextActive: '#006cd9',

    colorSuccessBg: '#11261e',
    colorSuccessBgHover: '#163025',
    colorSuccessBorder: '#2a6c51',
    colorSuccessBorderHover: '#3c8d64',
    colorSuccessHover: '#6fc097',
    colorSuccess: '#4baa7a',
    colorSuccessActive: '#3c8d64',
    colorSuccessTextHover: '#6fc097',
    colorSuccessText: '#4baa7a',
    colorSuccessTextActive: '#3c8d64',

    colorWarningBg: '#2b2a14',
    colorWarningBgHover: '#343318',
    colorWarningBorder: '#8d8733',
    colorWarningBorderHover: '#a3951f',
    colorWarningHover: '#e2dc7a',
    colorWarning: '#c9c556',
    colorWarningActive: '#a3951f',
    colorWarningTextHover: '#e2dc7a',
    colorWarningText: '#c9c556',
    colorWarningTextActive: '#a3951f',

    colorErrorBg: '#2b1616',
    colorErrorBgHover: '#3a1c1d',
    colorErrorBorder: '#7a3133',
    colorErrorBorderHover: '#a13f43',
    colorErrorHover: '#ff6f74',
    colorError: '#de494b',
    colorErrorActive: '#b9363a',
    colorErrorTextHover: '#ff6f74',
    colorErrorText: '#de494b',
    colorErrorTextActive: '#b9363a',

    colorText: '#e6edf3',
    colorTextBase: '#e6edf3',
    colorTextSecondary: '#bbbbbb',
    colorTextTertiary: '#8f9aa4',
    colorTextQuaternary: '#5b6670',

    colorBorder: '#3a4856',
    colorBorderSecondary: '#5b6670',
    colorSplit: '#3a4856',

    colorFill: '#263445',
    colorFillSecondary: '#283748',
    colorFillTertiary: '#314357',
    colorFillQuaternary: '#3a4c60',

    colorBgBase: '#18212c',
    colorBgContainer: '#1d2836',
    colorBgElevated: '#22313e',
    colorBgLayout: '#18212c',
    colorBgSpotlight: '#ffffffd9',

    controlItemBgHover: '#283748',
    controlItemBgActive: '#263445',
    controlItemBgActiveHover: '#314357',

    colorLink: '#0a8dff',
    colorLinkHover: '#33a7ff',
    colorLinkActive: '#006cd9',

    borderRadiusSM: 6,
    borderRadius: 8,
    borderRadiusLG: 12
  },
  algorithm: ['dark']
};
